import { render, staticRenderFns } from "./CultureBless.vue?vue&type=template&id=0c0fe927&scoped=true"
import script from "./CultureBless.vue?vue&type=script&lang=js"
export * from "./CultureBless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fe927",
  null
  
)

export default component.exports